<p class="back-text" *ngIf="!isMobile; else mobile">
  <i class="fa fa-arrow-left arrow"></i> Tillbaka
</p>
<ng-template #mobile
  ><p class="mobile-back-text">
    <i class="fa fa-arrow-left arrow"></i> Tillbaka
  </p></ng-template
>
